import React, { useContext } from "react";

import { Route, Routes } from "react-router-dom";

import Loading from "components/Loading";
import { AppContext } from "contexts/AppContext";

import BusinessApp from "./BusinessApp";

const AppRoutes = () => {
	const { tokenLoaded } = useContext(AppContext);

	if (!tokenLoaded) {
		return <Loading />;
	} else {
		return (
			<Routes>
				<Route path=":locale/*" element={<BusinessApp />} />
				<Route element={<BusinessApp />} />
			</Routes>
		);
	}
};

export default AppRoutes;
